import { get } from 'lodash'

import { type IApiError } from '@webapp/services/api'

export interface APIErrorParsed {
  code: string
  message: string
}

export type ErrorCodeMessageMap<E = any> = {
  [errorCode in keyof E]: string
}

export const parseAPIError = (
  errors: IApiError['data'],
  defaultMessage: string = 'Unexpected error',
  errorCodeMessageMap: ErrorCodeMessageMap = {}
): APIErrorParsed => {
  if (!errors) {
    return {
      code: null,
      message: defaultMessage,
    }
  }

  let nonFieldErrors = get(errors, 'errors.non_field_errors')

  // if non_field_errors doesn't exist, take the first property in errors.data.errors object
  if (!nonFieldErrors) {
    for (const prop in errors.errors) {
      if (errors.errors[prop].message) {
        nonFieldErrors = errors.errors[prop]
      }
    }
  }

  if (nonFieldErrors) {
    const errorMessage =
      errorCodeMessageMap[nonFieldErrors.code] ||
      nonFieldErrors.message ||
      defaultMessage

    return {
      code: nonFieldErrors.code,
      message: errorMessage,
    }
  }

  return {
    code: null,
    message: defaultMessage,
  }
}
